<template>
  <div class="spentTimeView_detail">

    <div class="weeklyBox" style="box-shadow: none;">
      <table cellspacing="0" cellpadding="0" class="weeklyReportTable">
        <tbody>
          <tr class="thead_tr">
            <!-- <td class="td_timeAdd" width="3%"></td> -->
            <td class="td_timeAdd" ></td>
            <td class="td_timeAdd" width="20%">&nbsp;</td>
            <td class="td_timeAdd td_center dayDateArea" width="8%">
              <span>一</span>
              <br />
              <span>{{spentTimeDateList[0]|weekDateShow}}</span>
            </td>
            <td class="td_timeAdd td_center dayDateArea" width="8%">
              <span>二</span>
              <br />
              <span>{{spentTimeDateList[1]|weekDateShow}}</span>
            </td>
            <td class="td_timeAdd td_center dayDateArea" width="8%">
              <span>三</span>
              <br />
              <span>{{spentTimeDateList[2]|weekDateShow}}</span>
            </td>
            <td class="td_timeAdd td_center dayDateArea" width="8%">
              <span>四</span>
              <br />
              <span>{{spentTimeDateList[3]|weekDateShow}}</span>
            </td>
            <td class="td_timeAdd td_center dayDateArea" width="8%">
              <span>五</span>
              <br />
              <span>{{spentTimeDateList[4]|weekDateShow}}</span>
            </td>
            <td class="td_timeAdd td_center redTitle dayDateArea" width="8%">
              <span>六</span>
              <br />
              <span>{{spentTimeDateList[5]|weekDateShow}}</span>
            </td>
            <td class="td_timeAdd td_center redTitle dayDateArea" width="8%">
              <span>七</span>
              <br />
              <span>{{spentTimeDateList[6]|weekDateShow}}</span>
            </td>
            <!-- <td class="td_timeAdd" width="4%">&nbsp;</td> -->
          </tr>
        </tbody>
        <tbody v-if="weeklyReportSpentTimeForm.projectList.length>0">
          <tr class="td_timeAdd_tr">
            <!-- <td class="td_timeAdd " :rowspan="projectRow" style="line-height: 20px;">项目</td> -->
            <td class="td_timeAdd" style="line-height: 20px;font-weight:bold">项目</td>
            <!-- <td class="td_timeAdd">项目类型</td> -->
            <td class="td_timeAdd" style="font-weight:bold">任务类别</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
          </tr>
          <tr class="td_timeAdd_tr" v-if="weeklyReportSpentTimeForm.projectList.length==0">
            <td class="td_timeAdd "></td>
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
          </tr>
          <tr v-else v-for="(projectItem,index) in weeklyReportSpentTimeForm.projectList" :key="index">
            <td class="td_timeAdd" style="line-height: 28px;">{{projectItem.projectName}}</td>
            <td class="td_timeAdd">{{projectItem.projectTaskName}}</td>
            <el-tooltip
              placement="bottom"
              effect="light"
              :disabled="!projectItem['Monday'].content">
              <div slot="content">{{projectItem['Monday'].content}}</div>
              <td class="td_timeAdd td_leftborder td_center"
                @dblclick="contentShow(projectItem['Monday'])">
                {{projectItem['Monday'].spentTime}}
                <div class="tipBar" v-if="projectItem['Monday'].content"></div>
              </td>
            </el-tooltip>

            <el-tooltip placement="bottom"
              effect="light"
              :disabled="!projectItem['Tuesday'].content">
              <div slot="content">{{projectItem['Tuesday'].content}}</div>
              <td class="td_timeAdd td_leftborder td_center" @dblclick="contentShow(projectItem['Tuesday'])">
                {{projectItem['Tuesday'].spentTime}}
                <div class="tipBar" v-if="projectItem['Tuesday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip placement="bottom"
              effect="light"
              :disabled="!projectItem['Wednesday'].content">
              <div slot="content">{{projectItem['Wednesday'].content}}</div>
              <td class="td_timeAdd td_leftborder td_center"
                @dblclick="contentShow(projectItem['Wednesday'])">
                {{projectItem['Wednesday'].spentTime}}
                <div class="tipBar" v-if="projectItem['Wednesday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip placement="bottom"
              effect="light"
              :disabled="!projectItem['Thursday'].content">
              <div slot="content">{{projectItem['Thursday'].content}}</div>
              <td
                class="td_timeAdd td_leftborder td_center"
                @dblclick="contentShow(projectItem['Thursday'])">
                {{projectItem['Thursday'].spentTime}}
                <div class="tipBar" v-if="projectItem['Thursday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip
              placement="bottom"
              effect="light"
              :disabled="!projectItem['Friday'].content">
              <div slot="content">{{projectItem['Friday'].content}}</div>
              <td class="td_timeAdd td_leftborder td_center" @dblclick="contentShow(projectItem['Friday'])">
                {{projectItem['Friday'].spentTime}}
                <div class="tipBar" v-if="projectItem['Friday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip
              placement="bottom"
              effect="light"
              :disabled="!projectItem['Saturday'].content">
              <div slot="content">{{projectItem['Saturday'].content}}</div>
              <td class="td_timeAdd td_leftborder td_center"
                @dblclick="contentShow(projectItem['Saturday'])">
                {{projectItem['Saturday'].spentTime}}
                <div class="tipBar" v-if="projectItem['Saturday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip
              placement="bottom"
              effect="light"
              :disabled="!projectItem['Sunday'].content">
              <div slot="content">{{projectItem['Sunday'].content}}</div>
              <td class="td_timeAdd td_leftborder td_center" @dblclick="contentShow(projectItem['Sunday'])">
                {{projectItem['Sunday'].spentTime}}
                <div class="tipBar" v-if="projectItem['Sunday'].content"></div>
              </td>
            </el-tooltip>
          </tr>
        </tbody>
        <tbody v-if="weeklyReportSpentTimeForm.taskList.length>0">
          <tr class="td_timeAdd_tr">
            <!-- <td class="td_timeAdd " :rowspan="taskRow" >一般</td> -->
            <td class="td_timeAdd" colspan="2" style="line-height: 20px;padding: 10px 5px;font-weight:bold">日常工作</td>
            <!-- <td class="td_timeAdd">&nbsp;</td> -->
            <td class="td_timeAdd td_leftborder"></td>
            <td class="td_timeAdd td_leftborder"></td>
            <td class="td_timeAdd td_leftborder"></td>
            <td class="td_timeAdd td_leftborder"></td>
            <td class="td_timeAdd td_leftborder"></td>
            <td class="td_timeAdd td_leftborder"></td>
            <td class="td_timeAdd td_leftborder"></td>
          </tr>
           <tr class="td_timeAdd_tr"
            v-if="weeklyReportSpentTimeForm.taskList.length==0">
            <td class="td_timeAdd " colspan="2"></td>
            <!-- <td class="td_timeAdd"></td> -->
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
            <td class="td_timeAdd td_leftborder">&nbsp;</td>
          </tr>
          <tr v-for="(taskItem,index) in  weeklyReportSpentTimeForm.taskList " :key="index">
            <td class="td_timeAdd" colspan="2" style="line-height: 28px;">{{taskItem.taskName}}</td>
            <!-- <td class="td_timeAdd"></td> -->
            <el-tooltip placement="bottom" effect="light" :disabled="!taskItem['Monday'].content">
              <div slot="content">{{taskItem['Monday'].content}}</div>
              <td class="td_timeAdd td_leftborder td_center" @dblclick="contentShow(taskItem['Monday'])">
                {{taskItem['Monday'].spentTime}}
                <div class="tipBar" v-if="taskItem['Monday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip placement="bottom" effect="light" :disabled="!taskItem['Tuesday'].content">
              <div slot="content">{{taskItem['Tuesday'].content}}</div>
              <td class="td_timeAdd td_leftborder td_center" @dblclick="contentShow(taskItem['Tuesday'])">
                {{taskItem['Tuesday'].spentTime}}
                <div class="tipBar" v-if="taskItem['Tuesday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip
              placement="bottom"
              effect="light"
              :disabled="!taskItem['Wednesday'].content">
              <div slot="content">{{taskItem['Wednesday'].content}}</div>
              <td class="td_timeAdd td_leftborder td_center" @dblclick="contentShow(taskItem['Wednesday'])">
                {{taskItem['Wednesday'].spentTime}}
                <div class="tipBar" v-if="taskItem['Wednesday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip placement="bottom" effect="light" :disabled="!taskItem['Thursday'].content">
              <div slot="content">{{taskItem['Thursday'].content}}</div>
              <td class="td_timeAdd td_leftborder td_center" @dblclick="contentShow(taskItem['Thursday'])">
                {{taskItem['Thursday'].spentTime}}
                <div class="tipBar" v-if="taskItem['Thursday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip placement="bottom" effect="light" :disabled="!taskItem['Friday'].content">
              <div slot="content">{{taskItem['Friday'].content}}</div>
              <td class="td_timeAdd td_leftborder td_center" @dblclick="contentShow(taskItem['Friday'])">
                {{taskItem['Friday'].spentTime}}
                <div class="tipBar" v-if="taskItem['Friday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip placement="bottom" effect="light" :disabled="!taskItem['Saturday'].content">
              <div slot="content">{{taskItem['Saturday'].content}}</div>
              <td class="td_timeAdd td_leftborder td_center" @dblclick="contentShow(taskItem['Saturday'])">
                {{taskItem['Saturday'].spentTime}}
                <div class="tipBar" v-if="taskItem['Saturday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip placement="bottom" effect="light" :disabled="!taskItem['Sunday'].content">
              <div slot="content">{{taskItem['Sunday'].content}}</div>
              <td class="td_timeAdd td_leftborder td_center" @dblclick="contentShow(taskItem['Sunday'])">
                {{taskItem['Sunday'].spentTime}}
                <div class="tipBar" v-if="taskItem['Sunday'].content"></div>
              </td>
            </el-tooltip>
          </tr>
        </tbody>
        <tbody>
          <tr>
            <td class="td_timeAdd " style="line-height: 20px;">总计</td>
            <!-- <td class="td_timeAdd" width="15%"></td> -->
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd td_leftborder td_center">{{weeklyReportSpentTimeForm.timeTotalList[0]}}</td>
            <td class="td_timeAdd td_leftborder td_center">{{weeklyReportSpentTimeForm.timeTotalList[1]}}</td>
            <td class="td_timeAdd td_leftborder td_center">{{weeklyReportSpentTimeForm.timeTotalList[2]}}</td>
            <td class="td_timeAdd td_leftborder td_center">{{weeklyReportSpentTimeForm.timeTotalList[3]}}</td>
            <td class="td_timeAdd td_leftborder td_center">{{weeklyReportSpentTimeForm.timeTotalList[4]}}</td>
            <td class="td_timeAdd td_leftborder td_center">{{weeklyReportSpentTimeForm.timeTotalList[5]}}</td>
            <td class="td_timeAdd td_leftborder td_center">{{weeklyReportSpentTimeForm.timeTotalList[6]}}</td>
          </tr>
        </tbody>
      </table>
        <p style="color:#777777;font-size:14px;margin-top:10px;">双击工时可查看工作内容。</p>
    </div>
  
    <el-dialog
      title="备注信息"
      :visible.sync="contentVisible"
      :close-on-click-modal="false"
      width="600px"
      @close="closeContentDialog()"
      class="contentModal"
      :close-on-press-escape="false"
      append-to-body>
      <div class="modalForm">
        <el-form
          :model="contentFormTemp"
          label-position="left"
          ref="contentFormTemp"
          size="small"
          label-width="60px"
          @submit.native.prevent>
          <el-form-item label="备注:" prop="serialNumber">
            <el-input
              type="textarea"
              v-model="contentFormTemp.content"
              :rows="6"
              disabled
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="text" @click="closeContentDialog()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { dateFtt } from "@/utils/auth.js";
export default {
  name: "weeklyReportView_SpentTime",
  props: [],
  data() {
    return {
      contentForm: {
        content: ""
      },
      contentFormTemp: {
        content: ""
      },
      contentVisible: false,

      weekDay: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      // UI展示数据
      weeklyReportSpentTimeForm: {
        id: "",
        description: "",
        attachedFiles:[],
        taskList: [],
        projectList: [],
        timeTotalList: []
      },
      spentTimeDateList: [], //当前周次的时间集合 从周一到周日
      //记录对应的条目有多少行，用来合并单元格
      projectRow: 2,
      taskRow: 2
    };
  },
  filters: {
    weekDateShow: function(value) {
      return dateFtt("MM/dd", value);
    }
  },
  methods: {

    clearData(){
      this.weeklyReportSpentTimeForm.id = "";
      this.weeklyReportSpentTimeForm.description = "";
      this.weeklyReportSpentTimeForm.attachedFiles = [];

      this.weeklyReportSpentTimeForm.taskList = [];
      this.weeklyReportSpentTimeForm.projectList = [];

    },
   
    //把数据加工成工时视图
    loadWeeklyReportData(data) {
      
      this.createWeekArray(data.monday);
      this.convertServerDataToViewData(data);
      this.computeDailyTotalSpentTime();
    },
    //按工时填写转化
    convertServerDataToViewData(resData) {
      this.weeklyReportSpentTimeForm.id = "";
      this.weeklyReportSpentTimeForm.description = "";
      this.weeklyReportSpentTimeForm.attachedFiles = [];

      this.weeklyReportSpentTimeForm.taskList = [];
      this.weeklyReportSpentTimeForm.projectList = [];

       if (resData == null) 
        return;

      let weeklyReportForm = resData;
      this.weeklyReportSpentTimeForm.description = resData.description;
      this.weeklyReportSpentTimeForm.attachedFiles = resData.attachedFiles;

      this.weeklyReportSpentTimeForm.id = resData.id;
      let spentTimeTaskArray = [];
      let spentTimeProjectArray = [];

      let currentDay;
      let weeklyReportItem_Task = weeklyReportForm.weeklyReportItem_Task || [];
      let weeklyReportItem_Project = weeklyReportForm.weeklyReportItem_Project || [];
      let weekDayTemp = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];
      /*
      获取已填报的周报，按照日常工作类型分类。
      格式[taskId:'',taskName:"",Monday:{},Tuesday:{},Wednesday:{},Thursday:{},Friday:{},Saturday:{},Sunday:{}]
      */
      weeklyReportItem_Task.forEach(taskItem => 
      {
        currentDay = weekDayTemp[new Date(taskItem.date).getDay()];

        if (spentTimeTaskArray.length == 0) 
        {
          let spentTimeTaskItem = {};
          spentTimeTaskItem.taskId = taskItem.taskId;
          spentTimeTaskItem.taskName = taskItem.taskName;
          spentTimeTaskItem[currentDay] = taskItem;
          spentTimeTaskArray.push(spentTimeTaskItem);
        } 
        else 
        {
          let needToAdd = true;

          for(let i=0;i<spentTimeTaskArray.length;i++)
          {
              let spentTimeItem = spentTimeTaskArray[i];

              if (spentTimeItem.taskId == taskItem.taskId 
                && spentTimeItem[currentDay] == undefined) 
              {
                needToAdd = false;
                spentTimeItem[currentDay] = taskItem;
                break;
              }
          }

           if (needToAdd) 
           {
            let unExistTaskItem = {};
            unExistTaskItem.taskId = taskItem.taskId;
            unExistTaskItem.taskName = taskItem.taskName;
            unExistTaskItem[currentDay] = taskItem;
            spentTimeTaskArray.push(unExistTaskItem);
           }

        }
      });

      /*
      获取已填报的周报，按照项目类型分类。
      格式[projectId:'',projectName:"",projectSerialNumber:"",Monday:{},Tuesday:{},Wednesday:{},Thursday:{},Friday:{},Saturday:{},Sunday:{}]
      */
      weeklyReportItem_Project.forEach(projectItem => 
      {
        currentDay = weekDayTemp[new Date(projectItem.date).getDay()];

        if (spentTimeProjectArray.length == 0) 
        {
          let spentTimeProjectItem = {};
          spentTimeProjectItem.projectId = projectItem.projectId;
          spentTimeProjectItem.projectTaskId = projectItem.projectTaskId;
          spentTimeProjectItem.projectName =projectItem.projectName;
          spentTimeProjectItem.projectTaskName =projectItem.projectTaskName;
          spentTimeProjectItem.projectSerialNumber =projectItem.projectSerialNumber;
          spentTimeProjectItem[currentDay] = projectItem;
          spentTimeProjectArray.push(spentTimeProjectItem);
        } 
        else 
        {
          let needToAdd = true;

          for(let i=0;i<spentTimeProjectArray.length;i++)
          {

            let spentTimeProjectItem = spentTimeProjectArray[i];

            if (spentTimeProjectItem.projectId == projectItem.projectId
              && spentTimeProjectItem.projectTaskId == projectItem.projectTaskId
              && spentTimeProjectItem[currentDay] == undefined
              )
            {
              needToAdd = false;
              spentTimeProjectItem[currentDay] = projectItem;
              break;
            }
          }

          if (needToAdd) 
          {
            let unSpentTimeProjectItem = {};
            unSpentTimeProjectItem.projectId = projectItem.projectId;
            unSpentTimeProjectItem.projectTaskId = projectItem.projectTaskId;
            unSpentTimeProjectItem.projectName = projectItem.projectName;
            unSpentTimeProjectItem.projectTaskName = projectItem.projectTaskName;
            unSpentTimeProjectItem.projectSerialNumber = projectItem.projectSerialNumber;
            unSpentTimeProjectItem[currentDay] = projectItem;
            spentTimeProjectArray.push(unSpentTimeProjectItem);
          }
        }
      });

      let fitWeeklyPortForm = this.fitEmptyweekDayReport(spentTimeTaskArray,spentTimeProjectArray);
      this.weeklyReportSpentTimeForm.taskList = fitWeeklyPortForm.spentTimeTaskArray;
      this.weeklyReportSpentTimeForm.projectList =fitWeeklyPortForm.spentTimeProjectArray;

      this.projectRow = this.weeklyReportSpentTimeForm.projectList.length + 2;
      
      if(this.weeklyReportSpentTimeForm.taskList.length == 0)
      {
        this.taskRow = this.weeklyReportSpentTimeForm.taskList.length + 2;
      }
      else
      {
         this.taskRow = this.weeklyReportSpentTimeForm.taskList.length + 1;
      }
      
    },
    //补充当前周次未填写周报日期的对象内容。
    //方法内注释部分为: 默认在没有填写周报的时候展示一条空数据
    fitEmptyweekDayReport(spentTimeTaskArray = [],spentTimeProjectArray = []) 
    {
      this.weekDay.forEach((dayItem, index) => {
        if (spentTimeTaskArray.length == 0) {
          // let taskitem = {};
          // taskitem[dayItem] = {};
          // taskitem[dayItem].spentTime = "";
          // taskitem[dayItem].content = "";
          // taskitem[dayItem].date = this.spentTimeDateList[index];
          // taskitem[dayItem].taskId = "";
          // taskitem[dayItem].numericalOrder = 1;
          // timeTask.push(taskitem);
        } else {
          spentTimeTaskArray.forEach(taskitem => 
          {
            if (!taskitem[dayItem]) 
            {
              taskitem[dayItem] = {};
              taskitem[dayItem].spentTime = "";
              taskitem[dayItem].content = "";
              taskitem[dayItem].date = this.spentTimeDateList[index];
              taskitem[dayItem].taskId = "";
              taskitem[dayItem].numericalOrder = 1;
            }
          });
        }
        if (spentTimeProjectArray.length == 0) {
          // let item = {};
          // item[dayItem] = {};
          // item[dayItem].content = "";
          // item[dayItem].date = this.spentTimeDateList[index];
          // item[dayItem].numericalOrder = 1;
          // item[dayItem].spentTime = "";
          // item[dayItem].projectId = "";
          // timeBusiness.push(item);
        } else {
          spentTimeProjectArray.forEach(item => {
            if (!item[dayItem]) {
              item[dayItem] = {};
              item[dayItem].content = "";
              item[dayItem].date = this.spentTimeDateList[index];
              item[dayItem].numericalOrder = 1;
              item[dayItem].spentTime = "";
              item[dayItem].projectId = "";
              // item[dayItem].projectSerialNumber = "";
            }
          });
        }
      });
      return {
        spentTimeTaskArray: spentTimeTaskArray,
        spentTimeProjectArray: spentTimeProjectArray
      };
    },
    //在工时视图统计每天的工时合计
    computeDailyTotalSpentTime() {
      this.weeklyReportSpentTimeForm.timeTotalList = [];

      this.weekDay.forEach(dayItem => {
        let sum = 0;
        this.weeklyReportSpentTimeForm.taskList.forEach(taskItem => {
          sum += Number(taskItem[dayItem].spentTime);
        });

        this.weeklyReportSpentTimeForm.projectList.forEach(item => {
          sum += Number(item[dayItem].spentTime);
        });
        if (sum == 0) {
          sum = "";
        }
        this.weeklyReportSpentTimeForm.timeTotalList.push(sum);
      });
    },
    //初始化每周日期
    createWeekArray(data) {
      this.spentTimeDateList = [];
    //  debugger
      for (var i = 0; i < 7; i++) {
        let itemDay = dateFtt(
          "yyyy/MM/dd hh:mm:ss",
          new Date(data).getTime() + 24 * 60 * 60 * 1000 * i
        );
        this.spentTimeDateList.push(itemDay);
      }
    },

    // 双击查看备注
    contentShow(currentline) {
      console.log(currentline);
      
      this.contentVisible = true;
      this.contentForm = currentline;
      this.contentFormTemp.content = currentline.content;
    },
    confirmContentbtn() {
      this.contentForm.content = this.contentFormTemp.content;
      this.contentVisible = false;
    },
    closeContentDialog() {
      this.contentFormTemp.content = "";
      this.contentVisible = false;
    }

  }
};
</script>


<style rel="stylesheet/scss" lang="scss">
.spentTimeView_detail {
  .dayDateArea
  {
    // border: solid 1px rgb(197, 216, 238);
    background-color: rgb(247, 247, 232);
  }

  .weeklyBox {
    margin-top: 0px;
    margin-bottom: 0px;
    padding: 10px 20px;
    padding-right: 0;
    // box-shadow: 0px 0px 0px 2px #f5f5f5;
    // box-shadow: inset 0px 0px 0px 4px #f5f5f5;
  }
  .weeklyReportTable {
     width:100%;
     border-collapse:collapse;
     border:1px solid #ebeef5;

   .td_spentTimeInput
    {
       border: solid 1px rgb(197, 216, 238) ;

        .el-input__inner
        {
          text-align: center;
        }
    }

    .el-input .el-input__inner,
    .el-input__icon,
    .el-form-item__content {
      border: none !important;
      height: 30px;
      line-height: 30px;
    }
    .el-textarea .el-textarea__inner {
      border: none !important;
    }
    .el-input.el-input--suffix,
    .projectChoose .el-input__inner {
      border-bottom: 1px solid #bbbbbb !important;
      border-radius: 0;
    }
    .td_timeAdd {
      border-bottom: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
      padding: 5px;
      position: relative;
      .el-form {
        height: 35px !important;
      }
      .td_leftborder {
        /* border-left: 1px solid #BBBBBB; */
        position: relative;
      }
    }
      .td_leftborder,
    .td_center {
      text-align: center;
    }
    .thead_tr td {
      border-top: 1px solid #ebeef5;
    }
    .td_timeAdd_tr {
      height: 30px;
      line-height: 30px;
    }
    .tipBar {
      height: 10px;
      width: 10px;
      background-image: url("../../assets/r2c2.jpg");
      position: absolute;
      right: 0px;
      bottom: 15px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/common/weeklyReportView_SpentTime.vue